module.exports = __webpack_public_path__ + "static/media/right-arrow-black.58a5bd0a.svg";